export default "__VITE_ASSET__8e00f829__"